/* eslint-disable prettier/prettier */
import { TranslationMap } from './default'

export const vi: TranslationMap = {
  "accountstatus.Active": "Hoạt động",
  "accountstatus.Inactive": "Không hoạt động",
  "accountstatus.Terminated": "Đã chấm dứt",
  "additionalitems.title": "Hạng mục bổ sung",
  "cart.addtocart": "Thêm vào giỏ hàng",
  "cart.addtocart.alreadyincart": "@@PRODUCT@@ đã có trong giỏ hàng",
  "cart.addtocart.currencylocked": "Hiện các mặt hàng trong giỏ hàng được mua bằng @@CURRENCY@@ . Không thể kết hợp nhiều loại tiền tệ trong cùng một đơn hàng. Để mua sản phẩm này, trước tiên vui lòng xóa @@SHOPPING_CART@@ của bạn.",
  "cart.addtocart.locked": "Đơn vị tiền tệ trong giỏ hàng của bạn đã được chuyển bằng @@CURRENCY@@ với địa điểm giao hàng sau @@LOCATION@@",
  "cart.addtocart.shiptolocked": "Các mặt hàng trong giỏ hàng của bạn được yêu cầu giao đến địa chỉ sau:\n\n@@LOCATION@@ \n\nĐể mua sản phẩm này, trước tiên hãy thay đổi địa điểm giao hàng phù hợp trong @@SHOPPING_CART@@ ",
  "cart.addtocart.success": "@@PRODUCT@@ đã được thêm vào giỏ hàng",
  "cart.empty": "Giỏ hàng của bạn hiện đang trống",
  "cart.empty.title": "Giỏ hàng của bạn đang trống",
  "cart.gotoproductlist": "Đến danh sách sản phẩm",
  "cart.nolongervalid": "Giỏ hàng của bạn không hợp lệ, vui lòng cập nhật để tiếp tục",
  "cart.recalculate": "Tính toán lại",
  "cart.recalculate.rounding": "Số lượng yêu cầu đã được làm tròn để phù hợp với qui cách đóng gói sản phẩm.",
  "cart.removefromcart.success": "@@PRODUCT@@ đã được xóa khỏi giỏ hàng",
  "cart.removeproduct": "Bạn có muốn xóa @@PRODUCT@@ khỏi giỏ hàng của mình không?",
  "cart.requestquote": "Yêu cầu báo giá",
  "cart.updatecart": "Cập nhật",
  "cart.updatecart.success": "@@PRODUCT@@ đã được cập nhật trong giỏ hàng của bạn",
  "dangerousgoodsclass.1": "Nổ (1)",
  "dangerousgoodsclass.2.1": "Khí dễ cháy (2.1)",
  "dangerousgoodsclass.2.2": "Khí không cháy (2.2)",
  "dangerousgoodsclass.2.3": "Khí độc (2.3)",
  "dangerousgoodsclass.3": "Chất lỏng dễ cháy (3)",
  "dangerousgoodsclass.4.1": "Chất rắn dễ cháy (4.1)",
  "dangerousgoodsclass.4.2": "Chất rắn dễ bắt lửa dễ cháy (4.2)",
  "dangerousgoodsclass.4.3": "Nguy hiểm khi ẩm ướt (4.3)",
  "dangerousgoodsclass.5.1": "Ôxy hóa (5.1)",
  "dangerousgoodsclass.6.1": "Độc (6.1)",
  "dangerousgoodsclass.6.2": "Hiểm họa sinh học (6.2)",
  "dangerousgoodsclass.7": "Phóng xạ (7)",
  "dangerousgoodsclass.8": "Ăn mòn (8)",
  "dangerousgoodsclass.9": "Có nhiều đặc tính khác (9)",
  "date.invalid": "Ngày đã chọn không hợp lệ",
  "datefilteroption.last3Months": "3 tháng trước",
  "datefilteroption.lastMonth": "Tháng trước",
  "datefilteroption.lastWeek": "Tuần trước",
  "datefilteroption.lastYear": "Năm trước",
  "field.duplicatedphonenumber": "Số điện thoại đã tồn tại",
  "field.invalid": "@@VALUE@@không hợp lệ",
  "field.invalidinternalemail": "Email không hợp lệ và phải được cung cấp bởi brenntag.com, brenntag-asia.com hoặc digib.com",
  "field.invalidphonenumber": "Số điện thoại không hợp lệ, hãy sử dụng định dạng +61212345678",
  "field.required": "@@VALUE@@ là yêu cầu",
  "filter.accessStatus": "Trạng thái truy cập",
  "filter.all": "Tất cả",
  "filter.allorders": "Tất cả các đơn đặt hàng",
  "filter.allproducts": "Tất cả sản phẩm",
  "filter.apply": "Áp dụng",
  "filter.brenntagOrderNumber": "Số đơn hàng của Brenntag",
  "filter.compliancerequired": "Yêu cầu tuân thủ",
  "filter.createddate": "Ngày tạo",
  "filter.customerName": "Tên khách hàng",
  "filter.customerNumber": "Mã số khách hàng",
  "filter.customerpo.placeholder": "Lọc theo số PO của khách hàng",
  "filter.customerponumber": "Số PO của khách hàng",
  "filter.dangerousgoods": "Hàng nguy hiểm",
  "filter.deliveryNumber": "Số phiếu giao hàng",
  "filter.deliverydate": "Ngày giao hàng theo yêu cầu",
  "filter.enddate": "Ngày cuối",
  "filter.filterby": "Lọc theo",
  "filter.filters": "Các tiêu chí lọc",
  "filter.from": "từ",
  "filter.hazardous": "Hàng hóa nguy hiểm",
  "filter.invoicenumber": "Số hóa đơn",
  "filter.lastlogindate": "Ngày đăng nhập gần nhất",
  "filter.myorders": "Đơn hàng của tôi",
  "filter.myproducts": "Sản phẩm của tôi",
  "filter.noresults": "không có kết quả ",
  "filter.orderdate": "Ngày đặt hàng",
  "filter.otherfilters": "Các tiêu chí lọc khác",
  "filter.pill.accessStatus": "Trạng thái truy cập",
  "filter.pill.brenntagOrderNumber": "Brenntag Order #",
  "filter.pill.createdDate": "Ngày tạo",
  "filter.pill.customerPONumber": "PO #",
  "filter.pill.dangerousGoods": "Hàng nguy hiểm",
  "filter.pill.deliveryDate": "Ngày giao hàng theo yêu cầu",
  "filter.pill.dueDate": "Ngày đáo hạn",
  "filter.pill.hazardousGoods": "Hàng hóa nguy hiểm",
  "filter.pill.invoiceNumber": "Số hóa đơn",
  "filter.pill.issueDate": "Ngày phát hành hóa đơn",
  "filter.pill.lastLoginDate": "Ngày đăng nhập",
  "filter.pill.orderDate": "Ngày đặt hàng",
  "filter.pill.packageType": "Loại đóng gói",
  "filter.pill.pricePointExists": "Sản phẩm có đơn giá",
  "filter.pill.productName": "Tên sản phẩm",
  "filter.pill.productNumber": "Số sản phẩm",
  "filter.pill.quoteDate": "Ngày chào giá",
  "filter.pill.requestedDeliveryDate": "Yêu cầu giao hàng",
  "filter.pill.resetAll": "Đặt lại tất cả các bộ lọc",
  "filter.pill.role": "Vai trò",
  "filter.pill.salesGroupId": "Công ty bán hàng",
  "filter.pill.searchQuery": "Tìm kiếm",
  "filter.pill.shipToLocationId": "Giao đến",
  "filter.pill.status": "Trạng thái",
  "filter.pill.updatedDate": "Ngày cập nhật",
  "filter.pill.userName": "Người sử dụng",
  "filter.placeholder.customerName": "Tìm kiếm theo tên khách hàng",
  "filter.placeholder.customerNumber": "Tìm kiếm theo mã khách hàng",
  "filter.placeholder.global": "Tìm kiếm sản phẩm, đơn đặt hàng hoặc hóa đơn...",
  "filter.placeholder.userEmail": "Tìm kiếm theo email",
  "filter.placeholder.username": "Tìm kiếm theo tên",
  "filter.pricePointExists": "Sản phẩm kèm giá",
  "filter.productName": "Tên sản phẩm",
  "filter.quoteNumber": "Số đơn báo giá",
  "filter.quotedate": "Ngày chào giá",
  "filter.role": "Vai trò",
  "filter.salesRepName": "Tên người bán hàng đại diện",
  "filter.salesorganisation": "Công ty bán hàng",
  "filter.search-salesorg.placeholder": "Tìm kiếm theo khách hàng hoặc Người bán hàng",
  "filter.search.placeholder": "Tìm kiếm",
  "filter.shipto": "Giao đến",
  "filter.startdate": "Ngày bắt đầu",
  "filter.status": "Trạng thái",
  "filter.until": "đến",
  "filter.updated": "Ngày cập nhật mới nhất",
  "filter.user": "Người sử dụng",
  "filter.userEmail": "Email",
  "filter.userName": "Tên",
  "footer.contactus": "Liên hệ chúng tôi",
  "footer.faqs": "Các câu hỏi thường gặp",
  "footer.privacypolicy": "Tuyên bố về Bảo vệ Dữ liệu và Quyền riêng tư",
  "footer.termsofuse": "Điều khoản sử dụng",
  "home.contact.1": "Liên hệ với nhóm Brenntag Connect",
  "home.contact.2": "F.A.Q.",
  "home.heading.1": "Xin chào, @@USERNAME@@",
  "home.heading.2": "Chào mừng bạn đến với Brenntag Connect!",
  "home.heading.3": "Brenntag Connect là nền tảng trực tuyến để bạn dễ dàng đặt hàng và có được các thông tin mới cập nhật.",
  "home.heading.4": "truy cập nhanh",
  "home.invoices.list.1": "Xem hóa đơn",
  "home.invoices.list.2": "Tải hóa đơn bảng PDF",
  "home.label.explore": "Khám phá",
  "home.label.viewinvoices": "Xem tất cả hóa đơn",
  "home.label.vieworders": "Xem tất cả các đơn hàng",
  "home.orders.list.1": "Xem lịch sử đơn hàng và trạng thái",
  "home.orders.list.2": "Tải CoA",
  "home.products.list.1": "Tìm kiếm sản phẩm tại danh mục của Brenntag",
  "home.products.list.2": "Xem và tải tài liệu SDS/TDS",
  "home.products.list.3": "Đặt hàng ",
  "home.profile.list.1": "Trích xuất thông tin xuất hóa đơn",
  "home.profile.list.2": "Trích xuất thông tin bên đặt hàng ",
  "home.profile.list.3": "Đặt lại Mật khẩu",
  "home.recent.invoices.due": "Hóa đơn mới đến hạn",
  "home.recent.invoices.issued": "Hóa đơn mới phát hành",
  "home.recent.orders.created": "Các đơn hàng mới được tạo ",
  "home.recent.orders.updated": "Đơn đặt hàng được cập nhật mới nhất",
  "invoice.customer": "khách hàng",
  "invoice.date": "Ngày phát hành",
  "invoice.dueDate": "Ngày đến hạn thanh toán",
  "invoice.noinvoicesfound": "Hóa đơn chưa phát hành\nHóa đơn chỉ được phát hành khi giao hàng.",
  "invoice.number": "Số hóa đơn",
  "invoicestatus.Cancelled": "Đã hủy",
  "invoicestatus.Open": "Chưa thanh toán",
  "invoicestatus.Paid": "Đã thanh toán",
  "invoicestatus.PaidOnline": "Đãt thanh toán trực tuyến",
  "invoicestatus.ProcessingPayment": "Đang tiến hành thanh toán",
  "isolanguage.en": "English",
  "isolanguage.id": "Bahasa Indonesia",
  "isolanguage.ko": "한국어",
  "isolanguage.th": "ไทย",
  "isolanguage.vi": "Tiếng Việt",
  "isolanguage.zh-CN": "中文（簡體)",
  "isolanguage.zh-TW": "中文（繁體）",
  "label.Landline": "Điện thoại cố định",
  "label.Mobile": "Điện thoại di động",
  "label.additionalinformation": "Thông tin thêm",
  "label.addresses": "Địa chỉ",
  "label.alternativesizes": "Kích thước thay thế",
  "label.amountdue": "Số tiền đến hạn",
  "label.any": "Bất kì",
  "label.anyquestions": "Có câu hỏi nào không?",
  "label.batchamount": "Số lượng lô",
  "label.batchnumber": "Số lô",
  "label.batchsize": "Kích thước lô",
  "label.billingaddress": "Địa chỉ xuất hóa đơn",
  "label.billtoaddress": "Xuất hóa đơn tới địa chỉ",
  "label.billtoaddresses": "Xuất hóa đơn tới các địa chỉ",
  "label.billtoaddressincorrect": "Để thay đổi thông tin địa chỉ của bạn, vui lòng liên hệ với chúng tôi qua cửa sổ Trò chuyện",
  "label.billtoaddressrequired": "Địa chỉ xuất hóa đơn là bắt buộc",
  "label.brenntagordernumber": "Số đơn hàng của Brenntag",
  "label.browseproducts": "Duyệt sản phẩm",
  "label.browseusers": "Duyệt người dùng",
  "label.button.attach": "Đính kèm",
  "label.button.changesalesorg": "Có, thay đổi công ty bán hàng",
  "label.button.editprofile": "Chỉnh sửa hồ sơ của tôi",
  "label.button.export": "Xuất",
  "label.button.nokeep": "Không, giữ",
  "label.button.update": "Cập nhật",
  "label.button.yesterminate": "Có, chấm dứt",
  "label.by": "bởi",
  "label.callus": "Gọi cho chúng tôi",
  "label.cancel": "Hủy bỏ",
  "label.category": "Loại",
  "label.changepassword": "Đặt lại mật khẩu",
  "label.changesalesorg": "Thay đổi công ty bán hàng",
  "label.changesalesorgwarning": "Bạn có chắc chắn muốn thay đổi công ty bán hàng không?",
  "label.checkingavailability": "Đang kiểm tra tính khả dụng…",
  "label.clickheretoreview": "Bấm vào đây để xem lại",
  "label.comments": "Bình luận",
  "label.company": "Công ty",
  "label.confirmeddeliveryamount": "Số lượng hàng giao đã xác nhận",
  "label.continueshopping": "Tiếp tục đặt hàng",
  "label.country": "Quốc gia",
  "label.creationdate": "Ngày tạo",
  "label.creditnote": "Credit Note",
  "label.customer": "khách hàng",
  "label.customername": "Tên khách hàng",
  "label.customernumber": "Mã số khách hàng",
  "label.customerponumber": "Số PO của khách hàng",
  "label.customerporeference": "Số PO của khách hàng",
  "label.customerporeferencemaxlength": "Số PO của khách hàng không được dài hơn @@LENGTH@@ ký tự",
  "label.customerporeferencerequired": "Số PO của khách hàng là bắt buộc",
  "label.dangerousgoodsclass": "Nhóm hàng nguy hiểm",
  "label.dangerousgoodscode": "DG",
  "label.datedelivered": "Ngày giao hàng",
  "label.datefrom": "Từ ngày",
  "label.dateissued": "Ngày phát hành",
  "label.dateto": "Đến ngày ",
  "label.debitnote": "Giấy báo nợ",
  "label.defaultlanguage": "Ngôn ngữ",
  "label.delete": "Xóa bỏ",
  "label.deliverynumber": "Số phiếu giao hàng",
  "label.details": "Chi tiết",
  "label.discountperpack": "Giảm giá mỗi gói",
  "label.distributionchannel": "Kênh phân phối",
  "label.division": "Bộ phận",
  "label.documents": "Tải tài liệu",
  "label.dontshowthis": "Không hiện lại điều này",
  "label.download.all": "Tải xuống tất cả",
  "label.download.pdf": "tải bằng PDF",
  "label.editmode": "chế độ chỉnh sửa",
  "label.email": "Địa chỉ email",
  "label.emailaddress": "Địa chỉ email",
  "label.exportdata": "Xuất dữ liệu",
  "label.exporting": "Đang xuất dữ liệu, vui lòng đợi vài giây....",
  "label.exportingerror": "Lỗi truy xuất, vui lòng thử lại.",
  "label.exportinglonger": "Vẫn đang truy xuất. Vui lòng đợi vài giây....",
  "label.exportingsuccess": "Truy xuất thành công.",
  "label.exportordersinvoicescsv": "Truy xuất dữ liệu về đơn đặt hàng và hóa đơn của bạn trực tiếp dưới dạng tệp CSV hoặc Excel (XLSX).",
  "label.exportselectcategory": "Chọn danh mục và khoảng  thời gian cho dữ liệu cần truy xuất.",
  "label.externaluserfile": "tệp thông tin người dùng bên ngoài",
  "label.filesattached": "tập tin đính kèm",
  "label.from": "Từ:",
  "label.fullname": "Họ và tên",
  "label.hazardousgoodscode": "HZ",
  "label.hazchem": "Hóa chất nguy hiểm",
  "label.internaluserfile": "tệp thông tin người dùng nội bộ",
  "label.invoice": "Hóa đơn",
  "label.invoice.status.Cancelled": "Đã hủy",
  "label.invoice.status.Open": "Chưa thanh toán",
  "label.invoice.status.Paid": "Đã thanh toán",
  "label.invoice.status.PaidOnline": "Đã thanh toán trực tuyến",
  "label.invoice.status.ProcessingPayment": "Đang tiến hành thanh toán",
  "label.item": "mặt hàng",
  "label.items": "mặt hàng",
  "label.language": "Ngôn ngữ",
  "label.lastlogin": "Lân đăng nhập gần nhất",
  "label.learn_more_about_brenntag": "Tìm hiểu thêm về Brenntag Connect",
  "label.logout": "Đăng xuất",
  "label.minimumquantity": "Số lượng tối thiểu",
  "label.myprofile": "Thông tin của tôi",
  "label.name": "Họ và tên",
  "label.next-step": "Bước tiếp theo",
  "label.no": "Không",
  "label.no-filesattached": "Không có tập tin đính kèm",
  "label.no-filesuploaded": "Không có tập tin nào được tải lên",
  "label.none": "Không ai",
  "label.nopriceavailable": "Chưa có giá",
  "label.notes": "Ghi chú",
  "label.orderNumber": "Số đơn hàng",
  "label.orderamount": "Tổng số lượng",
  "label.orderamount.zero": "Số lượng không được bằng 0, bạn có thể xóa sản phẩm trong giỏ hàng của mình.",
  "label.orderdate": "Ngày đặt hàng",
  "label.orderdetails": "Chi tiết đơn hàng",
  "label.orderfiles": "tệp thông tin đơn hàng",
  "label.orderlist": "Danh sách đơn hàng",
  "label.ordervalue": "Giá trị đơn hàng",
  "label.pack": "hình thức đóng gói ",
  "label.packaging": "Bao bì",
  "label.packaginginformation": "Thông tin bao bì",
  "label.packinggroup": "Nhóm đóng gói",
  "label.packsize": "hình thức đóng gói ",
  "label.packtype": "Loại đóng gói",
  "label.paymentreference": "số thanh toán tham chiếu",
  "label.paymentterms": "Điều khoản thanh toán",
  "label.payonline": "Trả tiền trực tuyến",
  "label.personalinfo": "Thông tin người dùng",
  "label.phonenumber": "Số điện thoại",
  "label.placeorder": "Đặt hàng",
  "label.placingorder": "Đặt hàng",
  "label.preferences": "Tham khảo",
  "label.previous-step": "Bước trước",
  "label.price": "Giá cả",
  "label.priceperpack": "Giá mỗi gói",
  "label.pricesareexclusiveofsurcharges": "Giá chưa bao gồm phụ phí hoặc thuế.",
  "label.pricesaresubjecttochange": "Giá trên có thể thay đổi.",
  "label.productname": "Tên sản phẩm",
  "label.productnumber": "Số sản phẩm",
  "label.products": "Các sản phẩm",
  "label.producttype": "Loại sản phẩm",
  "label.profile": "Hồ sơ",
  "label.purchaseOrderNumber": "Số đơn hàng của bạn:",
  "label.quantity": "Số lượng",
  "label.quantity.minimumorderamount": "Số lượng phải lớn hơn hoặc bằng @@MINIMUMORDERAMOUNT@@",
  "label.quantity.minimumorderquantity": "Số lượng phải lớn hơn hoặc bằng @@MINIMUMORDERQUANTITY@@",
  "label.quantity.tiereddiscounts": "Giảm giá theo số lượng có sẵn",
  "label.quantity.toolarge": "Giá trị quá lớn",
  "label.quantity.zero": "Giá trị phải lớn hơn 0",
  "label.quotedate": "Ngày báo giá",
  "label.quotenumber": "Số đơn báo giá",
  "label.records": "mặt hàng",
  "label.redirecttoadmin": "Chuyển đến giao diện quản trị",
  "label.remove": "Xóa",
  "label.removeproduct": "Xóa sản phẩm",
  "label.reorder": "Đặt lại",
  "label.reorderall": "Đặt  lại tất cả",
  "label.requestcancellation": "Yêu cầu hủy bỏ",
  "label.requestedamount": "Số tiền yêu cầu",
  "label.requesteddeliverydate": "Ngày giao hàng theo yêu cầu",
  "label.requesteddeliverydate.tooltip": "Xin lưu ý rằng ngày giao hàng tùy thuộc vào tình trạng hàng sẵn có và chỉ được đảm bảo sau khi có xác nhận từ chúng tôi.",
  "label.requesteddeliverydate.warning": "Tùy thuộc vào tình trạng hàng sẵn có và sự xác nhận của Brenntag.",
  "label.requesteddeliverydaterequired": "Ngày yêu cầu giao hàng là bắt buộc",
  "label.requestquote": "Yêu cầu báo giá",
  "label.retry": "Thử lại",
  "label.role": "Vai trò",
  "label.role.Admin": "Quản trị viên",
  "label.role.CSR": "CSR",
  "label.role.ReadUser": "xem người dùng",
  "label.role.SuperAdmin": "Quản trị viên cấp cao",
  "label.role.User": "Người sử dụng",
  "label.role.UserAdmin": "Quản trị viên người dùng",
  "label.role.UserManager": "Quản lý người sử dụng",
  "label.salesorganisation": "Công ty bán hàng",
  "label.scheduleddeliverydate": "Dự kiến ngày giao hàng",
  "label.selectpaymentmethod": "Hãy chọn phương thức thanh toán",
  "label.selectsalesorganisation": "Chọn công ty bán hàng",
  "label.shelflife": "Thời hạn sử dụng",
  "label.shippinginstructions": "Cách thức giao hàng",
  "label.shipto": "giao đến",
  "label.shiptoaddress": "Địa chỉ nhận hàng",
  "label.shiptoaddresses": "(Các) địa chỉ nhận hàng",
  "label.shiptoaddressincorrect": "Lựa chọn địa chỉ giao hàng rất quan trọng vì nó liên quan đến giá cả. Vui lòng liên hệ với chúng tôi qua Chat nếu địa chỉ giao hàng của bạn không chính xác",
  "label.shiptoaddressrequired": "Địa chỉ nhận hàng là bắt buộc",
  "label.shoppingcart": "Giỏ hàng",
  "label.size": "Kích thước",
  "label.soldtoaddress": "Địa chỉ người mua hàng",
  "label.sortby": "Sắp xếp theo",
  "label.specifications": "Thông số kỹ thuật",
  "label.statusacknowledged": "Đã nhận",
  "label.statusclosed": "Đã hoàn tất",
  "label.statusopen": "Đang xử lý, chưa giao xong",
  "label.storageconditions": "Điều kiện lưu trữ",
  "label.subtotal": "Tổng ",
  "label.tab.attachedfiles": "File đính kèm",
  "label.tab.attachnew": "Đính kèm mới",
  "label.tax": "Thuế suất",
  "label.temperatureconditions": "Điều kiện nhiệt độ",
  "label.termsandconditions": "Các điều khoản và điều kiện",
  "label.timezone": "Múi giờ",
  "label.total": "Tổng số",
  "label.type": "Loại",
  "label.unitprice": "Đơn giá",
  "label.unnumber": "Số UN",
  "label.updated": "Ngày cập nhật mới nhất",
  "label.user": "Người sử dụng",
  "label.validfrom": "Có hiệu lực từ",
  "label.validto": "Có hiệu lực đến",
  "label.viewquote": "Xem báo giá",
  "label.viewvideos": "Xem video hướng dẫn",
  "label.yes": "Đúng",
  "label.yourproductnumber": "Mã sản phẩm của bạn",
  "languageselection.modal.areyousure": "Bạn có chắc chắn muốn thay đổi ngôn ngữ của mình không?",
  "languageselection.modal.confirm": "Có, thay đổi ngôn ngữ",
  "languageselection.modal.description": "Ngôn ngữ bạn chọn sẽ được sử dụng cho email của bạn và mọi giao diện người dùng trong Brenntag Connect.",
  "languageselection.modal.title": "Thay đổi ngôn ngữ ưu tiên",
  "location.shipto.notavailable": "Sản phẩm này không có sẵn cho địa điểm giao hàng bạn đã chọn. Chọn một địa chỉ khác.",
  "logout.changeswillbelost": "Các thông tin thay đổi trên trang này sẽ bị mất nếu bạn đăng xuất.",
  "logout.confirmlogout": "Bạn có muốn tiếp tục không?",
  "logout.itemsinyourshoppingcartcanbelost": "Các mặt hàng trong giỏ hàng của bạn có thể bị mất nếu bạn đăng xuất.",
  "message.accessrestricted": "Bạn không có quyền truy cập. Vui lòng liên hệ với quản trị viên của bạn.",
  "message.admincsrredirect": "Bạn đang truy cập vào phần bạn không được phép",
  "message.areyousure": "Bạn có chắc không?",
  "message.changesalesorg": "Việc thay đổi đơn vị bán hàng sẽ ảnh hưởng đến danh mục sản phẩm, danh sách đơn hàng, báo giá, hóa đơn và tất cả các mặt hàng hiện có trong giỏ hàng tại Brenntag Connect. Bạn có thể quay trở lại bất cứ khi nào bạn cần.",
  "message.changeswillbelost": "Các thông tin thay đổi trên trang này sẽ bị mất.",
  "message.documentnotfound": "Đã xác định lỗi do tài liệu trùng lặp hoặc bị hỏng, hoặc không thể tải tài liệu mới.",
  "message.noitemstoshow": "Xin lỗi, không có mặt hàng nào để hiển thị",
  "message.noprices": "Liên hệ với chúng tôi qua cửa sổ trò chuyện để có giá cho sản phẩm này",
  "message.pagenotfound": "Trang này dường như bị thiếu",
  "message.productnaforshipto": "Địa chỉ giao hàng đã thay đổi hoặc không còn tồn tại. Bạn hãy chọn một địa chỉ khác.",
  "order.cancelmodal.button": "Yêu cầu hủy đơn đặt hàng",
  "order.cancelmodal.question": "Bạn có chắc chắn muốn hủy đơn hàng sau không?",
  "order.cancelmodal.questionfollowup": "Sau khi xác nhận yêu cầu hủy, đơn hàng của bạn sẽ bị xóa hoàn toàn",
  "order.cancelmodal.title": "Yêu cầu hủy đơn đặt hàng",
  "order.cancelmodal.title.poabbr": "PO",
  "order.coadocument": "Tài liệu CoA",
  "order.confirmationdocument": "Xác nhận đơn hàng",
  "order.history.batch": "Lô ",
  "order.history.batch_amount": "Số lượng từng lô",
  "order.history.bill_to": "Xuất hóa đơn cho",
  "order.history.comment_from_user": "Bình luận",
  "order.history.deliveryNumber": "Số lượng giao hàng",
  "order.history.delivery_date": "Ngày giao hàng",
  "order.history.delivery_information": "Thông tin giao hàng",
  "order.history.hide": "Ẩn ",
  "order.history.missing_productname": "Sản phẩm không có sẵn.",
  "order.history.nologs": "Không có thông tin cho đơn hàng này.",
  "order.history.number": "Số",
  "order.history.orderDetails": "Chi tiết đơn hàng",
  "order.history.orderStatus": "Tình trạng đơn hàng",
  "order.history.order_amount": "Tổng số lượng",
  "order.history.payment_terms": "Điều khoản thanh toán",
  "order.history.pricing_unit_value": "Đơn giá",
  "order.history.quantity_calculated": "Số lượng tính toán",
  "order.history.requested_delivery_date": "Ngày giao hàng theo yêu cầu",
  "order.history.ship_to": "Giao đến",
  "order.history.shipping_instructions": "Chỉ dẫn giao hàng",
  "order.history.show": "Chỉ",
  "order.history.sold_to": "Bán cho",
  "order.history.status": "Trạng thái",
  "order.history.subtotal_value": "Tổng giá trị ",
  "order.history.title": "Lịch sử đặt hàng",
  "order.history.total_value": "Tổng giá trị",
  "order.invoice.download": "Tải hóa đơn",
  "order.invoice.title": "Hóa đơn",
  "order.invoice.titlePlural": "Hóa đơn",
  "order.invoice.view": "Lượt xem",
  "order.requestchange.allorderlinesdeleted": "Đơn hàng của bạn phải có ít nhất một Sản phẩm để duy trì hoạt động. Để hủy đơn đặt hàng, vui lòng chọn “Yêu cầu hủy” hoặc liên hệ với chúng tôi qua trò chuyện.",
  "order.requestchange.close": "Đóng",
  "order.requestchange.closeeditmode": "Tắt chế độ chỉnh sửa",
  "order.requestchange.closeeditmodeconfirmation": "Có, tắt chế độ chỉnh sửa",
  "order.requestchange.closewarning": "Bạn có chắc chắn muốn tắt yêu cầu thay đổi không?",
  "order.requestchange.discardedwarning": "Tất cả các thay đổi chưa được lưu đối với đơn đặt hàng này sẽ bị mất hoàn toàn.",
  "order.requestchange.leavewarning": "Bạn có chắc chắn muốn rời khỏi trang này không?",
  "order.requestchange.placechangerequest": "Thay đổi đơn hàng tại đây",
  "order.requestchange.productnotavailable": "Sản phẩm hoặc giá không còn nữa nếu có yêu cầu thay đổi, vui lòng liên hệ với chúng tôi qua cửa sổ trò chuyện.",
  "order.requestchange.requestchange": "Yêu cầu thay đổi",
  "order.requestchange.shiptoaddressnotavailable": "Địa chỉ nhận hàng không đúng cho đơn hàng này, vui lòng chọn địa chỉ nhận hàng khác hoặc liên hệ với chúng tôi qua của sổ trò chuyện.",
  "order.requestchange.shiptoaddressnotavailablewarning": "Địa chỉ nhận hàng không đúng",
  "order.status.Acknowledged": "Đã nhận",
  "order.status.Cancelled": "Đã hủy",
  "order.status.Closed": "Đã hoàn tất",
  "order.status.Confirmed": "Đã xác nhận",
  "order.status.Invoiced": "Đã phát hành hóa đơn",
  "order.status.Open": "Đang xử lý, chưa giao xong",
  "order.status.OutForDelivery": "Đã lên lịch đi giao hàng",
  "order.status.Submitted": "Đã gửi",
  "order.success.message": "Đơn đặt hàng của bạn hiện đã được Brenntag xem xét. Khi quá trình xem xét này hoàn tất, bạn sẽ nhận được xác nhận với đầy đủ chi tiết. \n\nNếu bạn có bất kỳ thắc mắc nào hoặc muốn thực hiện bất kỳ thay đổi nào, vui lòng liên hệ với Brenntag qua cửu sổ trò chuyện.",
  "order.success.title": "Đề nghị của bạn đã được gửi",
  "page.AccessRestricted": "truy cập giới hạn",
  "page.CustomerList": "Khách hàng",
  "page.Home": "Trang chủ",
  "page.InvoiceList": "Hóa đơn",
  "page.NotFound": "Không tìm thấy trang (404)",
  "page.OrderList": "Đơn đặt hàng",
  "page.PaymentInvoice": "thanh toán trực tuyến",
  "page.ProductList": "Sản phẩm",
  "page.Profile": "hồ sơ của tôi",
  "page.QuoteList": "Báo giá",
  "page.SearchResultsFor": "Kết quả tìm kiếm cho",
  "page.TermsAndConditions": "Các điều khoản và điều kiện",
  "page.TermsOfUse": "Điều khoản sử dụng - Brenntag Connect",
  "page.UserList": "Người sử dụng",
  "paymentInvoice.error": "Hóa đơn của bạn không thể truy xuất. Hãy làm mới trang (refresh page) và thử lại.",
  "paymentInvoice.infoCard.credit": "Tín dụng",
  "paymentInvoice.infoCard.creditcardStoreInfo": "Brenntag không lưu trữ bất kỳ thông tin thẻ tín dụng nào của khách hàng.",
  "paymentInvoice.infoCard.debitNote": "Ghi nợ",
  "paymentInvoice.infoCard.downloadpdf": "tải bằng PDF",
  "paymentInvoice.infoCard.invoice": "Hóa đơn",
  "paymentInvoice.infoCard.price": "Giá bán",
  "paymentInvoice.infoCard.review": "Nhấn để xem lại ",
  "paymentInvoice.infoCard.terms": "các điều khoản và điều kiện",
  "paymentRedirect.error.heading": "Đã xảy ra lỗi",
  "paymentRedirect.error.subtitle": "Vui lòng thử lại hoặc liên hệ với chúng tôi qua cử sổ trò chuyện.",
  "paymentRedirect.error.title": "Đã xảy ra lỗi trong quá trình thanh toán, hóa đơn / giấy ghi nợ chưa được thanh toán",
  "paymentRedirect.invoiceList": "Danh sách hóa đơn",
  "paymentRedirect.invoiceNumber": "Số hóa đơn",
  "paymentRedirect.paidAmount": "Số tiền thanh toán",
  "paymentRedirect.paymentReference": "Số thanh toán tham chiếu",
  "paymentRedirect.pending.heading": "Chờ xác nhận",
  "paymentRedirect.pending.subtitle": "Brenntag sẽ xử lý ngay khi thanh toán được xác nhận và trạng thái tương ứng sẽ được cập nhật.",
  "paymentRedirect.pending.title": "Thanh toán của bạn đang chờ xác nhận từ nhà cung cấp dịch vụ thanh toán",
  "paymentRedirect.refused.heading": "Thanh toán bị từ chối",
  "paymentRedirect.refused.subtitle": "Vui lòng thử lại bằng một phương thức thanh toán khác.",
  "paymentRedirect.refused.title": "Thanh toán của bạn đã bị từ chối ",
  "paymentRedirect.success.heading": "Cảm ơn bạn",
  "paymentRedirect.success.subtitle": "Hóa đơn của bạn đã được thanh toán. Brenntag sẽ xử lý và cập nhật trạng thái hóa đơn.",
  "paymentRedirect.success.title": "Bạn đã thanh toán thành công và yêu cầu của bạn đang được xử lý",
  "paymentterms.A001": "120 ngày từ ngày hóa đơn và trước ngày 15 hàng tháng",
  "paymentterms.A002": "15  ngày từ ngày hóa đơn và trước ngày 25 hàng tháng",
  "paymentterms.A003": "15 ngày từ ngày hóa đơn và trước ngày 5 hàng tháng",
  "paymentterms.A004": "30  ngày từ ngày hóa đơn và trước ngày 10 hàng tháng",
  "paymentterms.A005": "30  ngày từ ngày hóa đơn và trước ngày 15 hàng tháng",
  "paymentterms.A006": "30  ngày từ ngày hóa đơn và trước ngày 20 hàng tháng",
  "paymentterms.A007": "30  ngày từ ngày hóa đơn và trước ngày 25 hàng tháng",
  "paymentterms.A008": "45 ngày từ ngày hóa đơn và trước ngày 20 hàng tháng",
  "paymentterms.A009": "45 ngày từ ngày hóa đơn và trước ngày 25 hàng tháng",
  "paymentterms.A010": "60 ngày từ ngày hóa đơn và trước ngày 10 hàng tháng",
  "paymentterms.A011": "60 ngày từ ngày hóa đơn và trước ngày 15 hàng tháng",
  "paymentterms.A012": "60 ngày từ ngày hóa đơn và trước ngày 20 hàng tháng",
  "paymentterms.A013": "60 ngày từ ngày hóa đơn và trước ngày 25 hàng tháng",
  "paymentterms.A014": "not applicable for VN",
  "paymentterms.A015": "90 ngày từ ngày hóa đơn và trước ngày 10 hàng tháng",
  "paymentterms.A016": "90 ngày từ ngày hóa đơn và trước ngày 15 hàng tháng",
  "paymentterms.A017": "90 ngày từ ngày hóa đơn và trước ngày 20 hàng tháng",
  "paymentterms.A018": "90 ngày từ ngày hóa đơn và trước ngày 25 hàng tháng",
  "paymentterms.A019": "60 ngày từ ngày hóa đơn và trước ngày 26 hàng tháng",
  "paymentterms.A020": "45 ngày từ ngày hóa đơn và trước ngày 10 hàng tháng",
  "paymentterms.A021": "not applicable for VN",
  "paymentterms.A022": "not applicable for VN",
  "paymentterms.A023": "not applicable for VN",
  "paymentterms.A024": "not applicable for VN",
  "paymentterms.A025": "not applicable for VN",
  "paymentterms.A026": "150 ngày từ ngày hóa đơn và tt vào ngày 25 hàng tháng",
  "paymentterms.B004": "4 ngày từ ngày hóa đơn",
  "paymentterms.B005": "5 ngày từ ngày hóa đơn",
  "paymentterms.B007": "7 ngày từ ngày hóa đơn",
  "paymentterms.B009": "9 ngày từ ngày hóa đơn",
  "paymentterms.B010": "10 ngày từ ngày hóa đơn",
  "paymentterms.B013": "13 ngày từ ngày hóa đơn",
  "paymentterms.B014": "14 ngày từ ngày hóa đơn",
  "paymentterms.B015": "15 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B018": "18 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B020": "20 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B021": "21 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B022": "22 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B028": "28 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B029": "29 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B030": "30 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B037": "37 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B038": "38 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B040": "40 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B045": "45 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B050": "50 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B055": "55 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B060": "60 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B065": "65 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B068": "68 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B070": "70 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B075": "75 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B080": "80 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B085": "85 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B090": "90 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B105": "105 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B120": "120 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B150": "150 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B180": "180 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.B360": "360 NGÀY  KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.BA01": "50% TRẢ TRƯỚC, 50% THANH TOÁN SAU 30 NGÀY TỪ NGÀY HÓA ĐƠN",
  "paymentterms.BA02": "30% TRẢ TRƯỚC, 70% THANH TOÁN SAU 30 NGÀY TỪ NGÀY HÓA ĐƠN",
  "paymentterms.BA03": "NOT APPLICABLE FOR VN",
  "paymentterms.BA04": "30% TRẢ TRƯỚC 70 % THANH TOÁN NGAY KHI NHẬN HÀNG",
  "paymentterms.BA05": "NOT APPLICABLE FOR VN",
  "paymentterms.BA06": "38% TRẢ TRƯỚC 20 % THANH TOÁN NGAY KHI NHẬN HÀNG",
  "paymentterms.BA07": "NOT APPLICABLE FOR VN",
  "paymentterms.BA08": "28% TRẢ TRƯỚC, 72% THANH TOÁN SAU 60 NGÀY TỪ NGÀY HÓA ĐƠN",
  "paymentterms.BA09": "NOT APPLICABLE FOR VN",
  "paymentterms.BA10": "NOT APPLICABLE FOR VN",
  "paymentterms.BA11": "20% TRẢ TRƯỚC 80 % THANH TOÁN NGAY KHI NHẬN HÀNG",
  "paymentterms.BA12": "NOT APPLICABLE FOR VN",
  "paymentterms.BA13": "NOT APPLICABLE FOR VN",
  "paymentterms.BA14": "50% TRẢ TRƯỚC, 50% THANH TOÁN SAU 45 NGÀY KỂ TỪ NGÀY HÓA ĐƠN",
  "paymentterms.BA15": "NOT APPLICABLE FOR VN",
  "paymentterms.BA16": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.BA17": "NOT APPLICABLE FOR VN",
  "paymentterms.BA18": "70% TRẢ TRƯỚC 30 % THANH TOÁN NGAY KHI NHẬN HÀNG",
  "paymentterms.BA19": "0% TRẢ TRƯỚC 80 % THANH TOÁN BẰNG TIỀN MẶT NGAY KHI NHẬN HÀNG",
  "paymentterms.BA20": "NOT APPLICABLE FOR VN",
  "paymentterms.BA21": "NOT APPLICABLE FOR VN",
  "paymentterms.BA22": "NOT APPLICABLE FOR VN",
  "paymentterms.BA23": "70% THANH TOÁN NGAY  KHI NHẬN HÀNG, 30 % THANH TOÁN SAU 75 NGÀY NHẬN HÀNG",
  "paymentterms.BA24": "50% trả trước, 50% thanh toán ngay khi nhận hàng",
  "paymentterms.BA25": "not applicable for VN",
  "paymentterms.BA26": "not applicable for VN",
  "paymentterms.BA27": "not applicable for VN",
  "paymentterms.BA28": "not applicable for VN",
  "paymentterms.BA29": "40% trả trước, 60% tiền mặt khi nhận hàng",
  "paymentterms.BA30": "not applicable for VN",
  "paymentterms.BA31": "90% tiền mặt trả trước, 10% sau 90DAYS",
  "paymentterms.BA32": "not applicable for VN",
  "paymentterms.BA33": "not applicable for VN",
  "paymentterms.BA34": "NOT APPLICABLE FOR VN",
  "paymentterms.BA35": "50% trả trước/50% 60 ngày từ ngày hóa đơn",
  "paymentterms.BADV": "thanh toán trước",
  "paymentterms.BB05": "not applicable for VN",
  "paymentterms.BB07": "not applicable for VN",
  "paymentterms.BB10": "not applicable for VN",
  "paymentterms.BB14": "not applicable for VN",
  "paymentterms.BB15": "not applicable for VN",
  "paymentterms.BB20": "not applicable for VN",
  "paymentterms.BB21": "not applicable for VN",
  "paymentterms.BB30": "not applicable for VN",
  "paymentterms.BB35": "not applicable for VN",
  "paymentterms.BB38": "not applicable for VN",
  "paymentterms.BB40": "not applicable for VN",
  "paymentterms.BB45": "not applicable for VN",
  "paymentterms.BB46": "not applicable for VN",
  "paymentterms.BB50": "not applicable for VN",
  "paymentterms.BB60": "not applicable for VN",
  "paymentterms.BB65": "not applicable for VN",
  "paymentterms.BB70": "not applicable for VN",
  "paymentterms.BB75": "not applicable for VN",
  "paymentterms.BB85": "not applicable for VN",
  "paymentterms.BB90": "not applicable for VN",
  "paymentterms.BB97": "not applicable for VN",
  "paymentterms.BB98": "not applicable for VN",
  "paymentterms.BB99": "not applicable for VN",
  "paymentterms.BCBD": "thanh toán tiền mặt trước khi  nhận hàng",
  "paymentterms.BCOD": "thanh toán tiền mặt ngay khi nhận hàng",
  "paymentterms.BD01": "not applicable for VN",
  "paymentterms.BD02": "not applicable for VN",
  "paymentterms.BD03": "not applicable for VN",
  "paymentterms.BD04": "not applicable for VN",
  "paymentterms.BD05": "not applicable for VN",
  "paymentterms.BD06": "not applicable for VN",
  "paymentterms.BD07": "not applicable for VN",
  "paymentterms.BD12": "not applicable for VN",
  "paymentterms.BD15": "not applicable for VN",
  "paymentterms.BD30": "not applicable for VN",
  "paymentterms.BD45": "not applicable for VN",
  "paymentterms.BD60": "not applicable for VN",
  "paymentterms.BD75": "NOT APPLICABLE FOR VN",
  "paymentterms.BD90": "NOT APPLICABLE FOR VN",
  "paymentterms.BDAA": "NOT APPLICABLE FOR VN",
  "paymentterms.BDAP": "NOT APPLICABLE FOR VN",
  "paymentterms.BE00": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.BE14": "not applicable for VN",
  "paymentterms.BE15": "not applicable for VN",
  "paymentterms.BE16": "15 ngày cuối tháng",
  "paymentterms.BE20": "not applicable for VN",
  "paymentterms.BE21": "not applicable for VN",
  "paymentterms.BE22": "not applicable for VN",
  "paymentterms.BE23": "20 ngày cuối tháng và trước 25 hàng tháng",
  "paymentterms.BE30": "30 ngày cuối tháng và trước 20 hàng tháng",
  "paymentterms.BE31": "cuối tháng và trước 25 hàng tháng",
  "paymentterms.BE32": "32 ngày cuối tháng và trước ngày 2 hàng tháng",
  "paymentterms.BE33": "60 ngày cuối tháng và trước ngày 2 hàng tháng",
  "paymentterms.BE45": "45 ngày cuối tháng",
  "paymentterms.BE60": "60 ngày cuối tháng",
  "paymentterms.BE61": "60 ngày cuối tháng và trước 20 hàng tháng",
  "paymentterms.BE62": "20 ngày cuối tháng và trước 15 hàng tháng",
  "paymentterms.BE63": "60 ngày cuối tháng và trước ngày 4 hàng tháng",
  "paymentterms.BE90": "90 ngày cuối tháng",
  "paymentterms.BE91": "90 ngày cuối tháng và trước ngày 5 hàng tháng",
  "paymentterms.BIMM": "THANH TOÁN NGAY",
  "paymentterms.BL15": "NOT APPLICABLE FOR VN",
  "paymentterms.BL21": "NOT APPLICABLE FOR VN",
  "paymentterms.BL30": "NOT APPLICABLE FOR VN",
  "paymentterms.BL45": "NOT APPLICABLE FOR VN",
  "paymentterms.BL60": "NOT APPLICABLE FOR VN",
  "paymentterms.BL61": "NOT APPLICABLE FOR VN",
  "paymentterms.BL75": "NOT APPLICABLE FOR VN",
  "paymentterms.BL90": "NOT APPLICABLE FOR VN",
  "paymentterms.BL91": "NOT APPLICABLE FOR VN",
  "paymentterms.BLAS": "NOT APPLICABLE FOR VN",
  "paymentterms.BP12": "NOT APPLICABLE FOR VN",
  "paymentterms.BP30": "NOT APPLICABLE FOR VN",
  "paymentterms.BP60": "NOT APPLICABLE FOR VN",
  "paymentterms.BPAA": "NOT APPLICABLE FOR VN",
  "paymentterms.BTAS": "THANH TOÁN NGAY KHI NHẬN HÀNG",
  "paymentterms.CAD1": "NOT APPLICABLE FOR VN",
  "paymentterms.CBO1": "NOT APPLICABLE FOR VN",
  "paymentterms.CBO2": "NOT APPLICABLE FOR VN",
  "paymentterms.CBO3": "NOT APPLICABLE FOR VN",
  "paymentterms.CBO4": "NOT APPLICABLE FOR VN",
  "paymentterms.CBO5": "NOT APPLICABLE FOR VN",
  "paymentterms.CNMT": "NOT APPLICABLE FOR VN",
  "paymentterms.D001": "NOT APPLICABLE FOR VN",
  "paymentterms.D002": "THANH TOÁN TRƯỚC",
  "paymentterms.D004": "not applicable for VN",
  "paymentterms.D005": "THANH TOÁN SAU 30 NGÀY TỪ NGÀY HÓA ĐƠN",
  "paymentterms.D006": "not applicable for VN",
  "paymentterms.D007": "45 ngày từ ngày hóa đơn",
  "paymentterms.D008": "60 ngày từ ngày hóa đơn",
  "paymentterms.D010": "not applicable for VN",
  "paymentterms.D011": "thanh toán sau 25 ngày từ ngày hóa đơn",
  "paymentterms.D012": "not applicable for VN",
  "paymentterms.D013": "not applicable for VN",
  "paymentterms.D014": "thanh toán trước khi giao hàng",
  "paymentterms.D015": "not applicable for VN",
  "paymentterms.D016": "2 ngày từ ngày hóa đơn",
  "paymentterms.D017": "90 ngày từ ngày hóa đơn",
  "paymentterms.DD01": "not applicable for VN",
  "paymentterms.DD02": "not applicable for VN",
  "paymentterms.DD03": "not applicable for VN",
  "paymentterms.E001": "cuối tháng 30 ngày và trước ngày 10 hàng tháng",
  "paymentterms.E002": "cuối tháng 30 ngày và trước ngày 15 hàng tháng",
  "paymentterms.E003": "cuối tháng 30 ngày và trước 20 hàng tháng",
  "paymentterms.E004": "cuối tháng 30 ngày và trước 25 hàng tháng",
  "paymentterms.E005": "cuối tháng 60 ngày và trước ngày 10 hàng tháng",
  "paymentterms.E006": "cuối tháng 60 ngày và trước 15 hàng tháng",
  "paymentterms.E007": "cuối tháng 60 ngày và trước 20 hàng tháng",
  "paymentterms.E008": "cuối tháng 60 ngày và trước 25 hàng tháng",
  "paymentterms.E009": "cuối tháng 90 ngày và trước ngày 10 hàng tháng",
  "paymentterms.E010": "cuối tháng 90 ngày và trước ngày 15 hàng tháng",
  "paymentterms.E011": "cuối tháng 90 ngày và trước 20 hàng tháng",
  "paymentterms.E012": "cuối tháng 90 ngày và trước 25 hàng tháng",
  "paymentterms.E013": "cuối tháng",
  "paymentterms.E014": "cuối tháng 30 ngày",
  "paymentterms.E015": "cuối tháng 30 ngày và trước ngày 5 hàng tháng",
  "paymentterms.E016": "cuối tháng 30 ngày và trước ngày 10 hàng tháng",
  "paymentterms.E017": "cuối tháng 30 ngày và trước 20 hàng tháng",
  "paymentterms.E018": "cuối tháng 30 ngày và trước 25 hàng tháng",
  "paymentterms.E019": "not applicable for VN",
  "paymentterms.E020": "not applicable for VN",
  "paymentterms.E021": "not applicable for VN",
  "paymentterms.E022": "not applicable for VN",
  "paymentterms.E023": "cuối tháng 60 ngày",
  "paymentterms.E024": "cuối tháng 60 ngày và trước ngày 5 hàng tháng",
  "paymentterms.E025": "cuối tháng 60 ngày và trước ngày 10 hàng tháng",
  "paymentterms.E026": "cuối tháng 60 ngày và trước ngày 15 hàng tháng",
  "paymentterms.E027": "not applicable for VN",
  "paymentterms.E028": "not applicable for VN",
  "paymentterms.E029": "not applicable for VN",
  "paymentterms.E030": "cuối tháng 90 ngày",
  "paymentterms.E031": "cuối tháng 90 ngày và trước ngày 7 hàng tháng",
  "paymentterms.E032": "not applicable for VN",
  "paymentterms.E033": "not applicable for VN",
  "paymentterms.E034": "cuối tháng hóa đơn và trước ngày 5 tháng tiếp theo",
  "paymentterms.E035": "cuối tháng hóa đơn và trước ngày 10 tháng tiếp theo",
  "paymentterms.E036": "not applicable for VN",
  "paymentterms.E037": "not applicable for VN",
  "paymentterms.E038": "not applicable for VN",
  "paymentterms.E039": "not applicable for VN",
  "paymentterms.E040": "not applicable for VN",
  "paymentterms.E041": "not applicable for VN",
  "paymentterms.E042": "not applicable for VN",
  "paymentterms.E043": "not applicable for VN",
  "paymentterms.E044": "not applicable for VN",
  "paymentterms.E045": "not applicable for VN",
  "paymentterms.E046": "not applicable for VN",
  "paymentterms.E047": "not applicable for VN",
  "paymentterms.E048": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.E049": "not applicable for VN",
  "paymentterms.E050": "not applicable for VN",
  "paymentterms.E051": "cuối tháng 210 ngày",
  "paymentterms.E052": "cuối tháng 105 ngày",
  "paymentterms.E053": "not applicable for VN",
  "paymentterms.E054": "not applicable for VN",
  "paymentterms.E055": "not applicable for VN",
  "paymentterms.E056": "not applicable for VN",
  "paymentterms.E057": "not applicable for VN",
  "paymentterms.E058": "cuối tháng 120 ngày",
  "paymentterms.E059": "not applicable for VN",
  "paymentterms.E060": "cuối tháng 45 ngày và trước ngày 15 hàng tháng",
  "paymentterms.E061": "64 ngày tính từ cuối tháng phát hành hóa đơn",
  "paymentterms.E062": "cuối tháng và trước ngày 10 tháng tiếp theo",
  "paymentterms.E063": "cuối tháng và trước ngày 26 tháng tiếp theo",
  "paymentterms.E064": "cuối tháng 31 ngày",
  "paymentterms.E065": "not applicable for VN",
  "paymentterms.E120": "120 ngày cuối tháng",
  "paymentterms.EA65": "NOT APPLICABLE FOR VN",
  "paymentterms.EM15": "cuối tháng 15 ngày",
  "paymentterms.EM20": "cuối tháng 20 ngày",
  "paymentterms.EM30": "30 ngày cuối tháng",
  "paymentterms.EM45": "cuối tháng 45 ngày",
  "paymentterms.EM65": "cuối tháng 65 ngày",
  "paymentterms.EM75": "cuối tháng 75 ngày",
  "paymentterms.EQ01": "NOT APPLICABLE FOR VN",
  "paymentterms.GR10": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.GR30": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.IK00": "not application for VN",
  "paymentterms.L001": "NOT APPLICABLE FOR VN",
  "paymentterms.L002": "NOT APPLICABLE FOR VN",
  "paymentterms.L003": "NOT APPLICABLE FOR VN",
  "paymentterms.L004": "NOT APPLICABLE FOR VN",
  "paymentterms.L005": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.L006": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.L007": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.L030": " NOT APPLICABLE FOR VN",
  "paymentterms.L105": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.L120": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.L150": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.L180": "NOT APPLICABLE FOR VIETNAM",
  "paymentterms.LD01": "NOT APPLICABLE FOR VN",
  "paymentterms.LD02": "NOT APPLICABLE FOR VN",
  "paymentterms.LD03": "NOT APPLICABLE FOR VN",
  "paymentterms.LVT0": "NOT APPLICABLE FOR VN",
  "paymentterms.M001": "NOT APPLICABLE FOR VN",
  "paymentterms.M002": "NOT APPLICABLE FOR VN",
  "paymentterms.MVT0": "NOT APPLICABLE FOR VN",
  "paymentterms.P001": "NOT APPLICABLE FOR VN",
  "paymentterms.P002": "NOT APPLICABLE FOR VN",
  "paymentterms.P003": "NOT APPLICABLE FOR VN",
  "paymentterms.P004": "NOT APPLICABLE FOR VN",
  "paymentterms.PBD1": "NOT APPLICABLE FOR VN",
  "paymentterms.PBD2": "NOT APPLICABLE FOR VN",
  "paymentterms.PBD3": "NOT APPLICABLE FOR VN",
  "paymentterms.PBD4": "NOT APPLICABLE FOR VN",
  "paymentterms.PBD5": "NOT APPLICABLE FOR VN",
  "paymentterms.PDC1": "NOT APPLICABLE FOR VN",
  "paymentterms.PDC2": "NOT APPLICABLE FOR VN",
  "paymentterms.PDC3": "NOT APPLICABLE FOR VN",
  "paymentterms.PDC4": "NOT APPLICABLE FOR VN",
  "paymentterms.PDC5": "NOT APPLICABLE FOR VN",
  "paymentterms.PUD1": "NOT APPLICABLE FOR VN",
  "paymentterms.PUD2": "NOT APPLICABLE FOR VN",
  "paymentterms.PUD3": "NOT APPLICABLE FOR VN",
  "paymentterms.PUD4": "NOT APPLICABLE FOR VN",
  "paymentterms.PUD5": "NOT APPLICABLE FOR VN",
  "paymentterms.TX07": "NOT APPLICABLE FOR VN",
  "paymentterms.TX30": "NOT APPLICABLE FOR VN",
  "paymentterms.TX45": "NOT APPLICABLE FOR VN",
  "paymentterms.TX60": "NOT APPLICABLE FOR VN",
  "paymentterms.TX90": "NOT APPLICABLE FOR VN",
  "paymentterms.WALL": "NOT APPLICABLE FOR VN",
  "paymentterms.WL01": "NOT APPLICABLE FOR VN",
  "paymentterms.Z001": "hình thức thành toán (test)",
  "paymentterms.ZB00": "not application for VN",
  "paymentterms.ZB01": "NOT APPLICABLE FOR VN",
  "paymentterms.ZB02": "NOT APPLICABLE FOR VN",
  "paymentterms.ZB03": "NOT APPLICABLE FOR VN",
  "paymentterms.ZB04": "NOT APPLICABLE FOR VN",
  "paymentterms.ZB05": "NOT APPLICABLE FOR VN",
  "phone.landline": "Điện thoại cố định",
  "phone.mobile": "Điện thoại di động",
  "product.altsizes.loadmore": "Tải thêm các quy cách thay thế",
  "product.discount.saveamount": "Lưu @@AMOUNT@@",
  "product.discount.savingspercentage": "Tiết kiệm @@PERCENTAGE@@",
  "product.documentType.msds": "Tài liệu SDS",
  "product.documentType.tds": "Tài liệu TDS",
  "product.documenterror": "Không thể truy xuất tài liệu",
  "product.loadingdocuments": "Đang tải tài liệu",
  "product.nodocuments": "Không có tài liệu",
  "product.safetyinformation": "Thông tin an toàn",
  "product.type.nonvaluated": "Mặt hàng không có giá trị",
  "product.type.packaging": "Bao bì",
  "product.type.returnable": "Bao bì tái sử dụng",
  "product.type.sample": "Mẫu ",
  "product.type.services": "Dịch vụ",
  "product.type.tolling": "Thu phí",
  "product.type.tolling-raw-material-nonvaluated": "Phí nguyên liệu thô không giá trị",
  "product.type.tradinggoods": "Hàng hóa thương mại",
  "quote.date": "Ngày chào giá",
  "quote.decline": "Từ chối báo giá",
  "quote.details": "Chi tiết báo giá",
  "quote.number": "Số Báo giá ",
  "quote.requoteproduct": "Sản phẩm chào giá lại",
  "quote.validfrom": "Có hiệu lực từ",
  "quote.validto": "Có hiệu lực đến",
  "quote.value": "Giá trị báo giá",
  "quotestatus.Declined": "Đã từ chối",
  "quotestatus.Expired": "Đã hết hạn",
  "quotestatus.InProgress": "Đang xử lý",
  "quotestatus.Open": "Đang xử lý, chưa xong",
  "quotestatus.Ordered": "Đã đặt hàng",
  "quotestatus.Submitted": "Đã gửi",
  "quotestatus.Upcoming": "Sắp tới",
  "regex.placeordertermsandconditions": "Khi đặt hàng, bạn đã chấp nhận @@TERMS_AND_CONDITIONS@@ của chúng tôi",
  "regex.reviewtermsandconditions": "Nhấp vào đây để xem lại @@TERMS_AND_CONDITIONS@@ của chúng tôi",
  "requestcancellation.request": "Tôi yêu cầu hủy đơn hàng với số : @@ORDER_NUMBER@@ và mã khách hàng: @@CUSTOMER_NUMBER@@. Vui lòng gửi xác nhận hoặc liên hệ lại nếu cần thêm thông tin.",
  "requestchanges.message.billToAddress": "- Địa chỉ thanh toán trước đây: \n@@LOCATION_OLD@@ \n\n- Địa chỉ thanh toán mới: \n@@LOCATION_NEW@@",
  "requestchanges.message.cancelproduct": "- Hủy sản phẩm này: \n\nSản phẩm: @@PRODUCT_NAME@@ \nID sản phẩm: @@PRODUCT_NUMBER@@",
  "requestchanges.message.comments": "- Nhận xét: \n@@COMMENTS_OLD@@ → @@COMMENTS_NEW@@",
  "requestchanges.message.deliverydate": "- Ngày giao hàng được yêu cầu: \n@@DATE_OLD@@ → @@DATE_NEW@@",
  "requestchanges.message.heading": "Bạn có thể vui lòng thay đổi thông tin sau cho đơn hàng của tôi không: \n\nMã khách hàng @@CUSTOMER_NUMBER@@ Số đơn hàng @@PURCHASE_ORDER_NUMBER@@ \n\n---------",
  "requestchanges.message.orderline": "- Đổi sản phẩm sau: \n\nSản phẩm: @@PRODUCT_NAME@@ \nID sản phẩm: @@PRODUCT_NUMBER@@ \n- Số lượng: @@QUANTITY_OLD@@ → @@QUANTITY_NEW@@ \n- Số tiền: @@AMOUNT_OLD@@ @@AMOUNT_UOM_OLD@@ → @@AMOUNT_NEW@@ @@AMOUNT_UOM_NEW@@",
  "requestchanges.message.shipToAddress": "- Địa chỉ giao hàng trước đây: \n@@LOCATION_OLD@@ \n\n- Địa chỉ giao hàng mới: \n@@LOCATION_NEW@@",
  "requestquote.request": "Vui lòng gửi báo giá cho đơn hàng sau: \n\nMã khách hàng @@CUSTOMER_NUMBER@@ \n\nSản phẩm: @@PRODUCT_NAME@@ \n\nID sản phẩm: @@PRODUCT_NUMBER@@ \n\nSố lượng yêu cầu: @@QUANTITY@@ \n\nSố tiền: @@REQUESTED_AMOUNT@@ \n\nĐịa chỉ giao hàng: \n@@SHIP_TO_ADDRESS@@ \n\nNgày giao hàng yêu cầu: @@REQUESTED_DELIVERY_DATE@@",
  "show_more.less": "Hiện ít hơn",
  "show_more.more": "Cho xem nhiều hơn",
  "show_more.results": "Hiển thị thêm kết quả",
  "something.wrong": "Oops! Đã xảy ra lỗi. Vui lòng thử lại",
  "something.wrong.documents": "Oops! Đã xảy ra sự cố",
  "sortinglabel.-currency": "Tiền tệ (ZA)",
  "sortinglabel.-customerName": "Tên khách hàng (ZA)",
  "sortinglabel.-dueDate": "ngày đáo hạn cập nhật",
  "sortinglabel.-grossAmount.amount": "Số tiền đến hạn cao nhất",
  "sortinglabel.-invoiceNumber": "Số hóa đơn (ZA)",
  "sortinglabel.-issueDate": "Hóa đơn mới nhất",
  "sortinglabel.-lastLoggedInAt": "Lần đăng nhập sau cùng",
  "sortinglabel.-lastUpdateDate": "Cập nhật mới nhất",
  "sortinglabel.-name": "Tên sản phẩm (ZA)",
  "sortinglabel.-netAmount": "Số tiền thực cao nhất",
  "sortinglabel.-orderCreationDate": "Đơn hàng mới nhất",
  "sortinglabel.-packaging.name": "Loại  đóng ngói (ZA)",
  "sortinglabel.-quoteCreationDate": "Ngày báo giá mới nhất",
  "sortinglabel.-username": "Tên (ZA)",
  "sortinglabel.-usertype": "Loại người dùng (Bên ngoài trước)",
  "sortinglabel.currency": "Tiền tệ (AZ)",
  "sortinglabel.customerName": "Tên khách hàng (AZ)",
  "sortinglabel.dueDate": "Ngày đến hạn cũ nhất",
  "sortinglabel.grossAmount.amount": "Số tiền đến hạn thấp nhất",
  "sortinglabel.invoiceNumber": "Số hóa đơn (AZ)",
  "sortinglabel.issueDate": "Hóa đơn cũ nhất",
  "sortinglabel.lastLoggedInAt": "Lần đăng nhập cũ gần nhất ",
  "sortinglabel.lastUpdateDate": "Cập nhật cũ nhất",
  "sortinglabel.name": "Tên sản phẩm (AZ)",
  "sortinglabel.netAmount": "Số tiền thực thấp nhất",
  "sortinglabel.orderCreationDate": "Đơn hàng cũ nhất",
  "sortinglabel.packaging.name": "Loại đóng gói (AZ)",
  "sortinglabel.quoteCreationDate": "Ngày báo giá cũ nhất",
  "sortinglabel.relevance": "Liên quan",
  "sortinglabel.username": "Tên (AZ)",
  "sortinglabel.usertype": "Loại người dùng (Nội bộ trước)",
  "storageconditions.01": "Kho thường-Thực phẩm, Dược phẩm",
  "storageconditions.02": "kho thường",
  "storageconditions.03": "kho nguy hiểm",
  "storageconditions.04": "Kho mát, thực phẩm, dược phẩm",
  "storageconditions.05": "Môi trường dễ cháy",
  "storageconditions.06": "Kho mát ",
  "storageconditions.07": "Kho  lạnh",
  "storageconditions.08": "Kho hóa chất",
  "storageconditions.09": "Kho amoniac",
  "storageconditions.10": "Lưu trữ không đúng chuẩn",
  "storageconditions.11": "Kho lưu trữ chất lỏng",
  "storageconditions.12": "Khu vực sản xuất",
  "support.email": "support@brenntagconnect.com",
  "support.email.salesgroup.NL01": "order.au@brenntag-asia.com",
  "support.email.topic": "Yêu cầu: {customer PO#}/ {quotation #}/ {customer ID}",
  "support.phonenumber": "+123 3453 043",
  "temperatureconditions.01": "> 25 đến 40ºC",
  "temperatureconditions.02": "> 15 đến 25ºC với độ ẩm được kiểm soát",
  "temperatureconditions.03": "> 8 đến 15ºC với độ ẩm được kiểm soát",
  "temperatureconditions.04": "> 0 đến 8ºC với độ ẩm được kiểm soát",
  "temperatureconditions.05": "> -20 đến 0ºC",
  "temperatureconditions.06": "-20ºC trở xuống",
  "terms.agree": "Vâng tôi đồng ý",
  "terms.description": "Khi bạn truy cập hoặc sử dụng bất kỳ phần nào của Brenntag Connect, bạn đã đồng ý ràng buộc bởi các Điều khoản sử dụng này.\n\nNếu bạn không đồng ý với tất cả các điều khoản và điều kiện của thỏa thuận này, bạn không thể truy cập Brenntag Connect hoặc sử dụng bất kỳ dịch vụ nào của nó",
  "terms.disagree": "Không, đăng xuất",
  "timeunit.many.day": "ngày",
  "timeunit.many.month": "tháng",
  "timeunit.many.week": "tuần",
  "timeunit.many.year": "năm",
  "timeunit.one.day": "ngày",
  "timeunit.one.month": "tháng",
  "timeunit.one.week": "tuần",
  "timeunit.one.year": "năm",
  "toast.error.coadocuments": "Đã xảy ra lỗi khi truy xuất tài liệu CoA",
  "toast.error.createuser": "Đã xảy ra lỗi khi tạo người dùng",
  "toast.error.customernotfound": "Đã xảy ra lỗi. Vui lòng liên hệ với Brenntag Connect.",
  "toast.error.customers": "Đã xảy ra lỗi khi truy xuất khách hàng",
  "toast.error.invoices": "Đã xảy ra lỗi khi truy xuất dữ liệu hóa đơn",
  "toast.error.languagechange": "Thay đổi ngôn ngữ thất bại",
  "toast.error.orderdetails": "Đã xảy ra lỗi khi truy xuất chi tiết đơn đặt hàng",
  "toast.error.orders": "Đã xảy ra lỗi khi truy xuất lịch sử đơn đặt hàng",
  "toast.error.placingorder": "Đã xảy ra lỗi khi đặt hàng",
  "toast.error.price": "Đã xảy ra lỗi khi truy xuất giá",
  "toast.error.productdocuments": "Đã xảy ra sự cố khi truy xuất tài liệu sản phẩm",
  "toast.error.products": "Đã xảy ra lỗi khi truy xuất dữ liệu sản phẩm",
  "toast.error.quote": "Đã xảy ra lỗi khi truy xuất chi tiết báo giá",
  "toast.error.quotereject": "Đã xảy ra sự cố khi từ chối báo giá",
  "toast.error.quotes": "Đã xảy ra lỗi khi truy xuất báo giá",
  "toast.error.saveuser": "Đã xảy ra sự cố khi lưu các thay đổi của người dùng",
  "toast.error.userinfo": "Đã xảy ra lỗi khi truy xuất thông tin người dùng",
  "toast.error.userservice": "Đã xảy ra lỗi khi truy xuất dữ liệu người dùng",
  "toast.error.userservice.emailaddressexists": "Người dùng có địa chỉ email @@EMAIL@@ đã tồn tại",
  "toast.error.userservice.permissionsoutsidesalesgroup": "Bạn không thể tạo hoặc sửa đổi người dùng nằm ngoài nhóm bán hàng bạn phụ trách",
  "toast.error.userservice.savefailed": "Đã xảy ra sự cố khi lưu dữ liệu người dùng",
  "toast.error.validatingcart": "Đã xảy ra lỗi khi xác thực giỏ hàng",
  "toast.success.createuser": "Người dùng @@USER@@ đã được tạo thành công",
  "toast.success.deleteuser": "Đã xóa thành công người dùng @@USER@@",
  "toast.success.resetpassword": "Chúng tôi vừa gửi lại cho bạn đường dẫn để đặt lại mật khẩu vào địa chỉ @@EMAIL@@ .",
  "toast.success.saveuser": "Người dùng @@USER@@ đã được lưu thành công",
  "user.accessrights": "Quyền truy cập và ngôn ngữ",
  "user.accessrights.message": "Chỉ định quyền truy cập cho khách hàng",
  "user.bcaccessstatus": "Trạng thái truy cập Brenntag Connect",
  "user.create": "Tạo người dùng",
  "user.createdon": "Được tạo ngày",
  "user.delete.confirmation": "Không thể hoàn tác, tiếp tục?",
  "user.delete.message": "Người dùng @@USER@@ sẽ bị xóa khỏi hệ thống không thể phục hồi được.",
  "user.edit": "chỉnh sửa thông tin người",
  "user.information": "Thông tin người dùng",
  "user.lastpasswordreset": "Đặt lại mật khẩu lần lần gần nhất",
  "user.modal.terminate.confirmation": "Bạn có chắc chắn muốn chấm dứt người dùng này không?",
  "user.modal.terminate.message": "Cảnh báo: Người dùng bị chấm dứt sẽ không thể đăng nhập vào Brenntag Connect nữa.",
  "user.notes": "Ghi chú",
  "user.notes.placeholder": "Ví dụ: thông tin về giờ làm việc, liên hệ dự phòng",
  "user.role": "Vai trò",
  "user.save": "Lưu thay đổi",
  "user.search.customer": "Tìm kiếm mã hoặc tên khách hàng",
  "user.selectcustomer": "Chọn khách hàng",
  "user.selectlanguage": "Chọn ngôn ngữ",
  "user.view": "Xem người dùng",
  "userEdit.cancel.confirm": "Bạn có chắc chắn muốn hủy không?",
  "userEdit.cancel.create.external": "Hủy 'tạo người dùng bên ngoài'",
  "userEdit.cancel.create.internal": "Hủy 'tạo người dùng nội bộ'",
  "userEdit.cancel.edit.external": "Hủy 'chỉnh sửa người dùng bên ngoài'",
  "userEdit.cancel.edit.internal": "Hủy 'chỉnh sửa người dùng nội bộ'",
  "userEdit.message.cannotedit": "Bạn không thể chỉnh sửa thông tin người sử dụng. Vui lòng liên hệ với nhân viên Brenntag nếu bạn muốn chỉnh sửa.",
  "userrole.Admin": "Quản trị viên",
  "userrole.CSR": "CSR",
  "userrole.ReadUser": "Người dùng chỉ  có quyền đọc",
  "userrole.SuperAdmin": "Quản trị viên cấp cao",
  "userrole.User": "Người sử dụng",
  "userrole.UserAdmin": "Quản trị viên Người dùng",
  "userrole.UserManager": "Quản lý người sử dụng",
  "userrole.description": "Vai trò người dùng",
  "validationerror.invalid-date": "Ngày đã chọn không hợp lệ",
  "validationerror.invalid-moq": "Số lượng đã chọn thấp hơn số lượng đặt hàng tối thiểu",
  "validationerror.not-authorized": "Không có quyền",
  "validationerror.not-found": "Sản phẩm này không tồn tại",
  "validationerror.price-changed": "Giá cho sản phẩm này đã được cập nhật",
  "validationerror.price-mismatch": "Một số giá đã được cập nhật",
  "validationerror.price-not-found": "Không tìm thấy giá cho sản phẩm này. Vui lòng liên hệ với chúng tôi qua cửa sổ trò chuyện.",
  "validationerror.uom-mismatch": "Đơn vị tính của sản phẩm này không phù hợp",
  "video.invoices": "Hóa đơn",
  "video.invoices.description": "Cách tìm kiếm và tải Hóa đơn trong Brenntag Connect",
  "video.ordering": "Đặt hàng và đặt  lại đơn hàng ",
  "video.ordering.description": "Cách Đặt hàng và cách đặt lại đơn hàng trong Brenntag Connect",
  "video.orderlist": "Xem danh sách đơn hàng",
  "video.orderlist.description": "Cách xem lịch sử đặt hàng của bạn trong Brenntag Connect",
  "video.productsearch": "Tìm kiếm sản phẩm",
  "video.productsearch.description": "cách tìm kiếm Sản phẩm trong Brenntag Connect"
} as const
